export class ViewportTracker {
  constructor() {
    this.visibleIds = {}
    this.onChange = null
  }

  update(bounds, allMonitors) {
    var newVisible = {}
    var keys = Object.keys(allMonitors)
    for (var i = 0; i < keys.length; i++) {
      var id = keys[i]
      var monitor = allMonitors[id]
      var coords = monitor.coordinates
      if (!coords || coords.length < 2) continue
      // Validate: lng must be -180..180, lat must be -90..90
      var lng = coords[0]
      var lat = coords[1]
      if (lat < -90 || lat > 90 || lng < -180 || lng > 180) continue
      try {
        if (bounds.contains(coords)) newVisible[id] = true
      } catch (e) {
        // Skip invalid coordinates
      }
    }
    if (!this._objectsEqual(this.visibleIds, newVisible)) {
      this.visibleIds = newVisible
      if (this.onChange) this.onChange(this.visibleIds)
    }
  }

  _objectsEqual(a, b) {
    var keysA = Object.keys(a)
    var keysB = Object.keys(b)
    if (keysA.length !== keysB.length) return false
    for (var i = 0; i < keysA.length; i++) {
      if (!b[keysA[i]]) return false
    }
    return true
  }
}
